import React, { memo } from 'react';

import { Skeleton } from '@atlassian/eoc-skeleton';

import { DIMENSIONS } from './constants';
import { LoadedResponderAvatar } from './main';
import { type ExternalResponderAvatarProps } from './types';

const ResponderAvatar = React.forwardRef<HTMLDivElement, ExternalResponderAvatarProps>(
	(props, ref) => {
		const { responder, size } = props;

		if (responder.isLoading) {
			return <Skeleton width={DIMENSIONS[size]} height={DIMENSIONS[size]} variant="circle" />;
		}

		return <LoadedResponderAvatar avatarRef={ref} {...props} />;
	},
);

export default memo(ResponderAvatar);
